import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Flodeskform from "./../../components/flodeskForm";
import BookList from "./../../components/bookList";
import PublicSpeakingTeaser from "./../../components/publicSpeakingTeaser";
import { withController } from 'react-scroll-parallax';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";

class Books extends Component {
  render() {
    return (
      <div className="full-height full-width">
        <Helmet>
          <title>{'Books by Kat Medina | The Joys of Jet Lag & Grumple'}</title>
          <meta name="description" content="Books by Kat Medina including The Joys of Jet Lag and Grumple - A Tahoe Tale of Kindness." />
        </Helmet>
        <BannerFadeIn>
          <div className="background-image-fill" style={{backgroundImage:`url(/images/blog-joy.jpg)`}}>
            <div className="brain-fucks-hero extra-large-padding centered-text" style={{backgroundColor:'rgba(0,0,0,.5)'}}>
              <h2 className="white full-width centered-text">{'Books by Kat Medina'}</h2>
              <p className="white">{'Don\'t just wait around for the world to bring you joy. Learn how to create it instead.'}</p>
            </div>
          </div>
        </BannerFadeIn>
        <BookList />
        <ScrollFadeIn>
          <Flodeskform />
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}

export default withController(Books);


// WEBPACK FOOTER //
// ./src/pages/books/index.js